<template>
  <v-container>
    <v-layout row wrap>
      <v-col v-if="!isGroupMember" cols="12" xs12 mt-5 justify-center>
        <GroupDetailComponent/>
      </v-col>
      <v-col v-else cols="7" xs7 mt-5 justify-center>
        <GroupDetailComponent/>
      </v-col>
      <v-col cols="5" xs4 mt-5 justify-center>
        <GroupChatComponent/>
      </v-col>
      
      <v-col cols="12" xs12 mt-5 justify-center>
        <v-dialog v-model="$store.state.groupJobFormModal" width="600" persistent>
          <group-job-form-component :form="groupJobForm"/>
        </v-dialog>
        <GroupJobListComponent/>
      </v-col>
    </v-layout>
    <div class="text-center" v-if="!isGroupMember">グループに参加することでチャットやグループジョブ一覧が閲覧できます</div>
  </v-container>
</template>
<script>
import {mapActions,mapGetters} from 'vuex'
import GroupDetailComponent from '../components/GroupDetail.vue';
import GroupChatComponent from '../components/GroupChat.vue';
import GroupJobFormComponent from '../components/GroupJobForm.vue';
import GroupJobListComponent from '../components/GroupJobList.vue';
export default {
  components: {
    GroupDetailComponent,
    GroupChatComponent,
    GroupJobFormComponent,
    GroupJobListComponent
  },
  created(){
    if(!this.$route.params.group_id) return
    const groupId = this.$route.params.group_id;
    this.fetchTheGroup(groupId);//グループ情報を取得する
    this.fetchMyGroupMembers(groupId);//グループメンバー情報を取得する
    this['job/fetchGroupJobs'](groupId);//グループジョブ情報を取得する
    this.fetchGroupChats(groupId)//グループチャット情報を取得する
    this.$store.state.groupFormModal = false;
  },
  computed:{
    isGroupMember(){
        const loginUserId = this.loginUserId
        return this.myGroupMembers.some(member => member.userId === loginUserId)
    },
    ...mapGetters(['loginUserId','group',"myGroupMembers"])
  },
  data () {
    return {
      groupJobForm:{
        title: 'グループジョブ作成',
        subTitle: '参加メンバーと一緒に取り組むジョブを作成することができます',
        buttonText: '作成'
      },
    }
  },
  methods:{
    isGroupLeader(){
       if(this.group.groupLeaderData){
         if(this.group.groupLeaderData.userId == this.loginUserId ){
           return true
         } 
         else {
           return false
         }
       }
       else return ""
     },
    ...mapActions([
      'toggleRecordJobModal',
      'toggleGroupJobFormModal',
      'fetchMyGroupMembers',
      'fetchTheGroup',
      'fetchGroupChats',
      'job/fetchGroupJobs'
      ])
  }
}
</script>
